export default __webpack_public_path__ + "static/media/salsa.00bebba3.jpg";